<script>
import { onMounted, ref } from '@vue/composition-api'
import "vue-croppa/dist/vue-croppa.css";
import settings from '@/views/admin/infotv/components/settings.vue'
import weather from '@/views/admin/infotv/components/weather.vue'
import logo from '@/views/admin/infotv/components/logo.vue'
import { mdiArrowLeft } from '@mdi/js';

export default {
    props: ["screen"],
    components: {
        weather,
        settings,
        logo
    },
    setup(props) {
        const tab = ref();
        const isLoading = ref(false);

        onMounted(() => {

        })

        return {
            tab,
            icons: {
                mdiArrowLeft
            }
        }
    }
}


</script>
<template>

    <v-card>
        <v-card-title>
            <router-link :to="{ name: 'admin-infotv-screens' }" class="mr-2">
                <v-icon>{{ icons.mdiArrowLeft }}</v-icon>
            </router-link>
            {{ $t("Asetukset") }}
        </v-card-title>
        <v-card-text>
            <v-card outlined>
                <v-card-text>
                    <v-tabs v-model="tab">
                        <v-tab key="darkmode">{{ $t('Ulkoasu') }}</v-tab>
                        <v-tab key="weather">{{ $t('Sää') }}</v-tab>
                        <v-tab key="logo">{{ $t('Logo') }}</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item key="darkmode">
                            <div class="my-5 pt-4">
                                <settings :screen="screen"></settings>
                            </div>
                        </v-tab-item>
                        <v-tab-item key="weather">
                            <div class="my-5 pt-4">
                                <weather :screen="screen"></weather>
                            </div>
                        </v-tab-item>
                        <v-tab-item key="logo">
                            <div class="my-5 pt-4">
                                <logo :screen="screen"></logo>
                            </div>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card-text>
            </v-card>
        </v-card-text>
    </v-card>

</template>
